import { render } from "./NotificationsAdminView.vue?vue&type=template&id=04674684"
import script from "./NotificationsAdminView.vue?vue&type=script&lang=js"
export * from "./NotificationsAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__